import React from 'react'
import PropTypes from 'prop-types'

class WelcomePage extends React.Component {

  render() {
    const { assets_path } = this.props
    
    /*if(first_load) return (
      <>
        <div 
          className="fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(/${assets_path}/images/welcome_bg.svg)`
          }}
        />
        <div className="fixed top-0 left-0 bottom-0 right-0 flex flex-col items-center justify-center">
          <Image
            src={`/${assets_path}/images/start_logo.svg`}
            width={225}
            height={92}
            alt="okidoki"
            preview={false}
          />
          <div className="mt-[14px] text-center">
            <Text className="text-[21px] text-white font-gilroy leading-[19.49px]">
              Добро пожаловать<br />
              в мир <b>вкусной еды!</b>
            </Text>
          </div>
        </div>
      </>
    )*/
    return (
      <>
        <div 
          className="fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(/${assets_path}/images/productbgnew.svg)`,
            backgroundColor: `#f6f6f6`
          }}
        />
        <div className="fixed top-0 left-0 bottom-0 right-0 flex flex-col items-center justify-center">
          <div className="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      </>
    )
  }
}

WelcomePage.propTypes = {
  assets_path: PropTypes.string
}

export default WelcomePage